export default "__VITE_ASSET__CgLZzJJ7__"